import React from 'react'

import './editUserProfile.css'

const EditUserProfile = ({id, userProfileData, userData}: any) => {
    
  return (
    <div>EditUserProfile</div>
  )
}

export default EditUserProfile